import { memo, useEffect } from "react";
import { Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { mdlActionFilterParams } from "../../models/domain/value-objects/ActionFilterParams";
import { enmPriceType } from "../../models/enums/PriceType";
import dayjs from "dayjs";
import { enmActionType } from "../../models/enums/ActionType";
import { enmCurrency } from "../../models/enums/Currency";
import { mdlSpoOffer } from "../../models/domain/SpoOffer";

export type ActionReportTableProps = {
    dataSource?: mdlSpoOffer[];
}

export const ActionReportTable = memo(function ActionReportTable(props: ActionReportTableProps) {
    const { t } = useTranslation();
    useEffect(() => {
    }, [props.dataSource]);

    type DataIndex = keyof mdlSpoOffer;

    const columns: TableProps<mdlSpoOffer>['columns'] = [
        {
            title: t("action.report.hotelName"),
            key: 'hotelName',
            dataIndex: "hotelName"
        },
        {
            title: t("action.report.agencyName"),
            key: 'agencyName',
            dataIndex: 'agencyName'
        },
        {
            title: t("action.report.market"),
            key: 'market',
            dataIndex: 'market'
        },
        {
            title: t("action.report.roomType"),
            key: 'roomType',
            dataIndex: 'roomType'
        },
        {
            title: t("action.report.priceType"),
            key: 'priceType',
            render: (e: mdlSpoOffer) => {
                switch (e.priceType) {
                    case enmPriceType.PER_PERSON:
                        return (t("action.report.priceTypePerPerson"));
                    default:
                        return (t("action.report.priceTypePerRoom"));
                }
            }
        },
        {
            title: t("action.report.sendDate"),
            key: 'sentDate',
            render: (e: mdlSpoOffer) => {
                return dayjs(e.sentDate).format("DD.MM.YYYY");
            }
        },
        {
            title: t("action.report.readDate"),
            key: 'readedDate',
            render: (e: mdlSpoOffer) => {
                return dayjs(e.readedDate).format("DD.MM.YYYY");
            }
        },
        {
            title: t("action.report.sellDateRange"),
            key: 'sellStartDate',
            render: (e: mdlSpoOffer) => {
                return `${dayjs(e.sellStartDate).format("DD.MM.YYYY")} - ${dayjs(e.sellEndDate).format("DD.MM.YYYY")}`;
            }
        },
        {
            title: t("action.report.accDateRange"),
            key: 'acconStartDate',
            render: (e: mdlSpoOffer) => {
                return `${dayjs(e.acconStartDate).format("DD.MM.YYYY")} - ${dayjs(e.acconEndDate).format("DD.MM.YYYY")}`;
            }
        },
        {
            title: t("action.report.spoType"),
            key: 'spoType',
            render: (e: mdlSpoOffer) => {
                if (e.price)
                    return (t("action.report.priceSpo"));
                else
                    return (t("action.report.discountSpo"));
            }
        },
        {
            title: t("action.report.price"),
            key: 'price',
            render: (e: mdlSpoOffer) => {
                return e.price ? `${e.price} ${enmCurrency[e.currency!]}` : "-";
            }
        },
        {
            title: t("action.report.discountRate"),
            key: 'discountRate',
            render: (e: mdlSpoOffer) => {
                return e.discountRate ? `% ${e.discountRate}` : "-";
            }
        },
        {
            title: t("action.report.senderName"),
            key: 'sender',
            dataIndex: 'sender'
        }
    ];


    return (
        <Table<mdlActionFilterParams>
            pagination={false}
            size="middle"
            columns={columns}
            scroll={{ x: 'max-content' }}
            dataSource={props.dataSource ? props.dataSource.map((action: mdlActionFilterParams, index: number) => ({ ...action, key: index })) : []}
        />
    )
})